import React, { useEffect, useState } from "react";
import { loadDecrypted } from "../../Common Usage/localStorageUtils";
import axios from "axios";

const AdminProfilesDetails = () => {
  const decryptUsersData = loadDecrypted("HeartConnect-StaffData");
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const coverPhoto =
    "https://png.pngtree.com/thumb_back/fw800/background/20240204/pngtree-frame-for-valentine-s-day-hearts-on-a-blue-background-image_15606172.png";

  useEffect(() => {
    getAllUsersData();
  }, []);

  const getAllUsersData = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/staff/get-staff/${decryptUsersData?._id}`,
      headers: {},
    };

    setIsLoading(true);
    axios
      .request(config)
      .then((response) => {
        console.log("response.data", response.data);
        setUsersData(response.data?.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="mx-auto mt-3 overflow-hidden rounded-xl bg-white shadow-md">
          <div className="relative">
            <div className="h-56 w-full animate-pulse bg-gray-200"></div>
            <div className="absolute left-1/2 top-32 -translate-x-1/2 transform">
              <div className="h-32 w-32 animate-pulse rounded-full border-4 border-white bg-gray-200"></div>
            </div>
          </div>
          <div className="pb-6 pt-10 text-center">
            <div className="mx-auto mb-3 h-4 w-24 animate-pulse rounded-xl bg-gray-200"></div>
            <div className="mx-auto h-6 w-48 animate-pulse rounded-xl bg-gray-200"></div>
          </div>
          <div className="grid grid-cols-1 gap-4 px-6 pb-6 tracking-wide sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3, 4, 5, 6].map((i) => {
              return (
                <div key={i} className="flex flex-col items-center">
                  <div className="mb-2 h-3 w-24 animate-pulse rounded bg-gray-200"></div>
                  <div className="h-4 w-32 animate-pulse rounded bg-gray-200"></div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="mx-auto mt-3 overflow-hidden rounded-xl bg-white shadow-md">
          <div className="relative">
            <img
              src={coverPhoto}
              alt="Cover"
              className="h-56 w-full object-cover"
            />
            <img
              src={
                usersData?.User?.selected_Avatar ||
                "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671142.jpg?size=338&ext=jpg&ga=GA1.1.2116175301.1719360000&semt=ais_user"
              }
              alt="Profile"
              className="absolute left-1/2 top-32 h-32 w-32 -translate-x-1/2 transform rounded-full border-4 border-white"
            />
          </div>
          <div className="pb-6 pt-10 text-center">
            {/* <span className="mb-4 cursor-pointer rounded-xl px-4 py-1 text-sm tracking-wide text-[#c51369] hover:bg-[#c51369] hover:text-white">
              Edit Profile
            </span> */}
            <h2 className="text-2xl font-semibold tracking-wide">
              {usersData?.fullName}
            </h2>
          </div>
          <div className="grid grid-cols-1 gap-4 px-6 pb-6 tracking-wide sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
            <div className="flex flex-col items-center">
              <p className="font-medium text-navy-700">Phone</p>
              <p className="text-[#c51369]">{usersData?.phoneNumber}</p>
            </div>
            <div className="flex flex-col items-center">
              <p className="font-medium text-navy-700">Role</p>
              <p className="capitalize text-[#c51369]">
                {usersData?.rolePermission?.rolename}
              </p>
            </div>
            <div className="flex flex-col items-center">
              <p className="font-medium text-navy-700">Gender</p>
              <p className="capitalize text-[#c51369]">{usersData?.gender}</p>
            </div>
            {/* <div className="flex flex-col items-center">
              <p className="font-medium text-navy-700">Location</p>
              <p className="text-[#c51369]">
                {usersData?.User?.current_Location}
              </p>
            </div> */}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default AdminProfilesDetails;
